import { supabase } from "@/integrations/supabase/client";
import { TimelineMode } from "@/constants/timeline-modes";

export async function getDefaultTimelineMode(empresaId: string): Promise<TimelineMode> {
  try {
    const { data, error } = await supabase
      .from("empresas")
      .select("default_timeline_mode")
      .eq("id", empresaId)
      .single();

    if (error) {
      if (error.code === "PGRST116") {
        // Coluna não existe - migration não foi executada
        console.warn("⚠️ Coluna 'default_timeline_mode' não existe. Execute a migration em SETUP_TIMELINE_MODE.md");
      } else {
        console.warn("Erro ao carregar modo timeline:", error);
      }
      return "confeccao";
    }

    return (data?.default_timeline_mode || "confeccao") as TimelineMode;
  } catch (error) {
    console.error("Erro ao carregar modo timeline:", error);
    return "confeccao";
  }
}

export async function setDefaultTimelineMode(empresaId: string, mode: TimelineMode): Promise<boolean> {
  try {
    const { error } = await supabase
      .from("empresas")
      .update({ default_timeline_mode: mode, updated_at: new Date().toISOString() })
      .eq("id", empresaId);

    if (error) {
      console.error("Erro ao salvar modo timeline:", error);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Erro ao salvar modo timeline:", error);
    return false;
  }
}
